import styled from 'styled-components'
import theme from 'theme_'

export const StyledHomeSubscriptionPlan = styled.div`
  align-items: center;
  display: flex;
  font-weight: 700;
  color: ${theme.colors.otterWarmBlack};
`

export const StyledHomeSubscriptionPlanIcon = styled.div`
  margin-right: 3px;
`

export const PlanName = styled.span`
  text-align: left;
`
